import React from 'react';
import { SvgIcon } from '@material-ui/core';

const Key3 = props => (
    <SvgIcon shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="nonzero" clipRule="evenodd" viewBox="0 0 10240 10240" {...props}>
	<path id="curve1" d="M4441 4442l-3064 3063c-62,62 -93,138 -93,226l0 542c0,140 85,259 218,304l952 317c117,39 239,10 327,-77l0 0 0 -586c0,-176 144,-320 320,-320l585 0 0 -585c0,-176 144,-320 320,-320l585 0 0 -585c0,-176 144,-320 320,-320l585 0 302 -302c-394,-188 -738,-464 -1008,-801l-2828 2827 64 -516 2576 -2576c-59,-93 -113,-191 -161,-291z"/>
	<path id="curve0" d="M7040 640c1414,0 2560,1146 2560,2560 0,1414 -1146,2560 -2560,2560 -1414,0 -2560,-1146 -2560,-2560 0,-1414 1146,-2560 2560,-2560zm640 1280c-353,0 -640,287 -640,640 0,353 287,640 640,640 353,0 640,-287 640,-640 0,-353 -287,-640 -640,-640z"/>
    </SvgIcon>
);
export default Key3;

